<template>
  <div class="bindHis-wrapper">
    <!-- 空状态 -->
    <van-empty
      v-if="!list || list.length === 0"
      image="search"
      description="暂无申请记录"
    />

    <!-- 列表项：使用 van-cell 替代 van-cell-group 减少 DOM 嵌套 -->
    <van-cell
      v-for="(item, index) in list"
      :key="item.id || index"
      :border="false"
      :class="['bindHis-item', 'bindHis-item--' + getStatusType(item.status)]"
    >
      <!-- 左侧图标 -->
      <template #icon>
        <van-icon name="contact" size="24" color="#969799" style="margin-right: 12px; margin-top: 2px;" />
      </template>

      <!-- 主体内容区 -->
      <div class="bindHis-content">
        <div class="bindHis-header">
          <span class="bindHis-name">{{ item.realName }}</span>
          <span
            class="bindHis-status"
            :class="'status-' + getStatusType(item.status)"
          >
            {{ getStatusText(item.status) }}
          </span>
        </div>
        <div class="bindHis-account">{{ item.bankAccount }}</div>
        <div class="bindHis-remark">{{ item.remark || '无备注' }}</div>
      </div>

      <!-- 右侧箭头（预留点击跳转） -->
      <!-- <template #right-icon>
        <van-icon name="arrow" size="16" color="#c8c9cc" />
      </template> -->
    </van-cell>
  </div>
</template>

<script>
// 数字状态映射表
const STATUS_TEXT_MAP = {
  1: '申请中',
  2: '绑定成功',
  3: '申请失败'
}

const STATUS_CLASS_MAP = {
  1: 'pending',
  2: 'success',
  3: 'failed'
}

export default {
  name: 'BindHisCard',
  props: {
    accountList: {
      type: Array,
      default: () => [],
      validator: (val) => {
        if (!Array.isArray(val)) return false
        return val.every(
          (item) => item && typeof item.realName === 'string' && typeof item.bankAccount === 'string'
        )
      }
    }
  },
  computed: {
    list () {
      return this.accountList || []
    }
  },
  methods: {
    getStatusText (status) {
      return STATUS_TEXT_MAP[String(status)] || '未知'
    },
    getStatusType (status) {
      return STATUS_CLASS_MAP[String(status)] || 'default'
    }
  }
}
</script>

<!-- ⚠️ 注意：这里使用 lang="css"，无需安装 sass-loader -->
<style scoped>
/* ========== 容器样式 ========== */
.bindHis-wrapper {
  padding: 12px;
  background-color: #f7f8fa;
  min-height: 80vh;
  box-sizing: border-box;
  padding-bottom: calc(12px + env(safe-area-inset-bottom));
  -webkit-overflow-scrolling: touch;
}

/* ========== 卡片基础样式 ========== */
.bindHis-item {
  background-color: #ffffff;
  border-radius: 12px !important;
  margin-bottom: 12px;
  overflow: hidden;
  transform: translateZ(0);
  -webkit-transform: translateZ(0);
}

/* 重置 van-cell 默认内边距，让内容区自行控制 */
.bindHis-item ::v-deep .van-cell__title,
.bindHis-item ::v-deep .van-cell__value {
  padding: 0;
}

.bindHis-item ::v-deep .van-cell {
  padding: 14px 16px;
  align-items: flex-start;
}

/* ========== 内容区排版 ========== */
.bindHis-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.bindHis-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.bindHis-name {
  font-size: 15px;
  font-weight: 600;
  color: #323233;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bindHis-account {
  font-size: 14px;
  color: #323233;
  line-height: 1.4;
  margin-bottom: 4px;
}

.bindHis-remark {
  font-size: 12px;
  color: #969799;
  line-height: 1.4;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* ========== 状态标签基础样式 ========== */
.bindHis-status {
  flex-shrink: 0;
  font-size: 12px;
  line-height: 1;
  padding: 3px 8px;
  border-radius: 4px;
  margin-left: 8px;
}

/* ========== 状态颜色映射（纯CSS类） ========== */
/* 1-申请中 */
.status-pending {
  background-color: #fffbe8;
  color: #ff976a;
}

/* 2-已成功 */
.status-success {
  background-color: #f0f9eb;
  color: #07c160;
}

/* 3-已失败 */
.status-failed {
  background-color: #fff2f0;
  color: #ee0a24;
}

/* 兜底-未知 */
.status-default {
  background-color: #f5f5f5;
  color: #969799;
}
</style>
